var _rect, _g, _rect2, _path, _use, _use2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 300,
    fill: "#ce1126"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fcd116",
    stroke: "#bd9c08",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "M349.39,141.29c8.76,2.35,22.01,1.76,27.96,8.71-8.75-2.35-19.55,11.81-27.96,8.71,7.43,5.2-108.04,0-98.78,0-8.76-2.35-22.01-1.76-27.96-8.71,8.75,2.35,19.55-11.81,27.96-8.71-7.43-5.2-20.31-9.23-23.3-17.75,7.43,5.2,22.54-4.44,29.26,1.38-5.2-7.42-16.07-15.57-15.83-24.64,5.2,7.43,22.71,3.45,27.02,11.3-2.34-8.76-9.41-20.05-6.44-28.57,2.35,8.758,19.98,10.933,21.53,19.86,0.79-9.031-2.4-22.103,3.72-29.049-0.79,9.033,15.13,17.097,13.43,26.026,3.83-8.217,5.95-21.492,13.43-26.026-3.83,8.218,8.67,21.199,3.72,29.049,6.41-6.409,12.6-18.286,21.53-19.86-6.41,6.411,0.42,22.74-6.44,28.57,8.21-3.83,17.91-12.877,27.02-11.3-8.22,3.83-7.41,21.54-15.83,24.64,9.04-0.79,21.17-5.91,29.26-1.38-9.03,0.79-14.04,17.75-23.3,17.75z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    d: "M258.36,150l-31.59-12.91,34.1-1.33-25.27-22.94,32.5,10.42-15.9-30.198,26.98,20.898-4.61-33.809,18.2,28.869,7.23-33.353,7.23,33.353,18.2-28.869-4.61,33.809,26.97-20.898-15.89,30.198,32.49-10.42-25.26,22.94,34.09,1.33-31.58,12.91,31.58,12.91h-146.45l31.59-12.91z"
  }), /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 1.8,
    cx: 300,
    cy: 150,
    r: 41.358
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.6,49.862l22.18,0.147c0.14-0.938-1.9-2.805-3.65-3.078-5.61-0.882-9.82,0.936-16.64,1.006l-1.89,1.925z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.43,44.643c5.21,6.58,15.31,11.153,24.95,11.213,13,0.08,27.42-10.441,44.85-13.662l-56.91-1.172c-7.37-5.045-12.96-4.405-16.77-1.277l-10.88,0.329c-1.54,0.839,1.27,4.343,3.55,4.471l11.21,0.098z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.16,40.868c-2.07-9.518-9.71-13.62-18.89-14.837-10.61-1.406-35.02-2.847-51.24-7.505,7.02,6.901,21.71,10.346,31.92,11.904,10.81,1.65,21.33,4.054,29.67,10.351l8.54,0.087z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M288.27,47.221c3.39,4.354,8.65,4.108,14.31,0.309,5.64-3.786,11.77-14.447,14.73-14.622,20.69-1.202,45.72-9.936,57.66-16.681-15.14,2.143-30.14,4.573-45.41,4.633-26.05,0.104-29.13,11.968-39.75,20.286"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    d: "M292.31,42.103c5.55-3.536,10.06-8.151,15.26-12.006,8.61-6.382,18.55-6.569,29.23-6.701,9.46-0.116,26.04-4.069,35.04-6.178"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M286.53,40.436c-1.63-8.511-9.6-11.065-19.66-12.594-10.95-1.663-22.12-2.589-33.04-5.607-2.71-0.748-5.23-2.07-7.85-3.105"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    d: "M290.02,52.983c10.28,0.754,17.91-2.336,26.68-6.706"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    d: "M254.63,41.831h12.96"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#bd9c08",
    stroke: "none",
    cx: 271.75,
    cy: 40.437,
    r: 1.62
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#003f87",
    width: 600,
    height: 135,
    y: 165
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "w",
    fill: "#fff",
    d: "M0,257.14c20,0,40,12.86,60,12.86s40-12.86,60-12.86,40,12.86,60,12.86,40-12.86,60-12.86,40,12.86,60,12.86,40-12.86,60-12.86,40,12.86,60,12.86,40-12.86,60-12.86,40,12.86,60,12.86,40-12.86,60-12.86v-21.43c-20,0-40,12.86-60,12.86s-40-12.86-60-12.86-40,12.86-60,12.86-40-12.86-60-12.86-40,12.86-60,12.86-40-12.86-60-12.86-40,12.86-60,12.86-40-12.86-60-12.86-40,12.86-60,12.86-40-12.86-60-12.86v21.43z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w",
    y: -42.8571
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w",
    y: -85.7142
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKi);
export default __webpack_public_path__ + "static/media/ki.f44f8acee0e3805741f77047c14918bb.svg";
export { ForwardRef as ReactComponent };